// main.ts 에서만 호출한다. 최초 설정용
import { addMessages, getLocaleFromNavigator, init } from 'svelte-i18n';
import en from '../translations/en.json';
import ja from '../translations/ja.json';
import ko from '../translations/ko.json';
import zaizai from '../translations/zaizai.json';
import zh from '../translations/zh.json';
// typescript 에서는 dynamic import 를 하려면 rollup.config.js 의 default 에 "inlineDynamicImports: true" 를 추가하면 되나
// 막상 build 를 하면 브라우저에서 동작하지 않는다. (큰 용량의 translation json 이 필요하면 그때에 도입하자.)
addMessages('ko', ko);
addMessages('ko-kr', ko);
addMessages('ko-KR', ko);
addMessages('en', en);
addMessages('en-us', en);
addMessages('en-US', en);
addMessages('ja', ja);
addMessages('ja-jp', ja);
addMessages('ja-JP', ja);
addMessages('zh', zh);
addMessages('zh-cn', zh);
addMessages('zh-CN', zh);
addMessages('zaizai', zaizai);
const fallbackLocale = 'en';
const navigatorLocale = getLocaleFromNavigator();
init({
    fallbackLocale,
    initialLocale: [
        'ko', 'ko-kr', 'ko-KR',
        'en', 'en-us', 'en-US',
        'ja', 'ja-jp', 'ja-JP',
        'zh', 'zh-cn', 'zh-CN',
        'zaizai',
    ].includes(navigatorLocale) ? navigatorLocale : fallbackLocale,
});
